
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useTranslationAdd } from '@/modules/translation/model/add';
import { ROUTE_NAME_TRANSLATION } from '@/modules/translation/router';

export default defineComponent({
    name: ROUTE_NAME_TRANSLATION.ADD,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, actions } = useTranslationAdd();

        return { v$, model, actions };
    }
});
